import { render, staticRenderFns } from "./AcFeeDetailsTable.vue?vue&type=template&id=28e8b16a&scoped=true"
import script from "./AcFeeDetailsTable.vue?vue&type=script&lang=js"
export * from "./AcFeeDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./AcFeeDetailsTable.vue?vue&type=style&index=0&id=28e8b16a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e8b16a",
  null
  
)

/* custom blocks */
import block0 from "./AcFeeDetailsTable.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports